import { ApproveItemUseCase } from '../../../application';

export default class ApproveItemService {
    async RequestData(event) {
        const data = await ApproveItemUseCase(event);

        return data;
    }
}
